module.exports = __webpack_public_path__ + "img/50.f10baf30.png";